<features [featureBase]="featureBase"></features>
<div class="action-btns-wrapper">
    <button *ngIf="!isPortal" class="btn btn-outline-secondary" (click)="gotoList()">
        <i class="pi pi-arrow-left"></i>
        <span translate>BACK_LIST</span>
    </button>
    <button *ngIf="isPortal" class="btn btn-outline-secondary" (click)="goBackLocation()">
        <i class="pi pi-arrow-left"></i>
        <span translate>BACK</span>
    </button>
    <button *ngIf="hideNewButton" type="button" class="btn btn-primary" (click)="saveFeature()">
        <span translate>SAVE</span>
    </button>
</div>
